<template>
    <section>
        <filter-control @params="fetch" ref="FilterControl" :model="model" :headers="headers" :query="query">
        </filter-control>
        <section>
            <div class="panel">
                <table class="table table-sm table-hover  table-bordered table-condensed">
                    <slot name="thead"></slot>
                    <tbody>
                        <slot v-for="(item, i) in dados" :dropup="i > dados.length - 3 && dados.length > 3"
                            :item="item">
                        </slot>
                    </tbody>
                </table>
                <filter-foot @applyChange="fetch" :showLinkDeleted="showLinkDeleted" :model="model"
                    :collection="collection" :query="query">
                </filter-foot>
            </div>
        </section>
    </section>
</template>

<script>
    import FilterControl from './FilterControl';
    import FilterFoot from './FilterFoot';
    import axios from 'axios';
    import Vue from 'vue';
    export default {
        props: {
            url: String,
            storeName: String,
            model: String,
            headers: Array,
            storeAction: String,
            storeResume: String,
            showLinkDeleted: Boolean,
            disableAutoGet: Boolean,
        },
        components: {
            FilterControl,
            FilterFoot
        },
        data() {
            return {
                query: {
                    order_column: 'created_at',
                    order_direction: 'desc',
                    filter_match: 'and',
                    limit: 5,
                    page: 1
                },
                collection: {
                    data: []
                }
            }
        },
        computed: {
            dados() {
                return _.get(this.$store.state, this.storeName);
            }
        },
        methods: {
            fetch(params) {
                this.$refs.FilterControl.loading = true;
              /*   const filters = this.$refs.FilterControl.getFilters();
                const params = {
                    ...filters,
                    ...this.query
                }; */
                axios.get(this.url, {
                        params: params
                    })
                    .then(res => {
                        //console.log(res.data);
                        if (res.data.collection) {
                            //Salvando os dados na loja.
                            this.$store.dispatch(this.storeAction, res.data.collection.data);
                            Vue.set(this.$data, 'collection', res.data.collection);
                            this.query.page = res.data.collection.current_page;
                        }
                        if (res.data.resume) {
                            this.$store.dispatch(this.storeResume, res.data.resume);
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$refs.FilterControl.loading = false;
                    })
                    .then(() => {
                        this.$refs.FilterControl.loading = false;
                    });
            }
        }
    }
</script>